import { render } from "./CreateMatch.vue?vue&type=template&id=4a1c8266"
import script from "./CreateMatch.vue?vue&type=script&lang=js"
export * from "./CreateMatch.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Kuppen_front/Kuppen_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__